import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { clearStudentAuthSession } from "../utils/authSession";

function NotAuthProvider({ children }) {
    const [wait, setWait] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem('token');
        const forceLogin = sessionStorage.getItem('student_force_login') === '1';
        sessionStorage.removeItem('student_force_login');

        if (forceLogin || location.state?.forceLogin) {
            clearStudentAuthSession();
            setWait(false);
            return;
        }

        if (token) {
            navigate('/home', { replace: true });
        }
        setWait(false);
    }, [navigate, location.state]);

    return (
        <AuthContext.Provider value={{ wait, user: null, setUser: () => {}, refreshUser: async () => null }}>
            {!wait && children}
        </AuthContext.Provider>
    );
}

export default NotAuthProvider;
